import positions from './Position'

export default {
  [positions.TOP_LEFT]: {
    top: 50,
    left: 50
  },
  [positions.TOP_RIGHT]: {
    top: 50,
    right: 50
  },
  [positions.BOTTOM_LEFT]: {
    bottom: 50,
    left: 50
  },
  [positions.BOTTOM_RIGHT]: {
    bottom: 50,
    right: 50
  }
}
